import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/dentlab/src/components/ui/dialog";
import { Button } from "@/dentlab/src/components/ui/button";
import { useTemplatesStore } from "@/dentlab/src/store/Templates";

interface ArticleCodeChangeDialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	templateIds: number[];
	oldCode: string;
	newCode: string;
	onKeepInTemplates: () => void;
	onRemoveFromTemplates: () => void;
	onCancel: () => void;
}

export const ArticleCodeChangeDialog: React.FC<ArticleCodeChangeDialogProps> = ({
	open,
	onOpenChange,
	templateIds,
	oldCode,
	newCode,
	onKeepInTemplates,
	onRemoveFromTemplates,
	onCancel,
}) => {
	const { templatesLookup } = useTemplatesStore((state) => ({
		templatesLookup: state.templatesLookup,
	}));

	const templateNames = templateIds
		.map((id) => templatesLookup[id]?.name || templatesLookup[id]?.code || `Template ${id}`)
		.filter(Boolean);

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>Artikelcode ändern</DialogTitle>
					<DialogDescription asChild>
						<div>
							<p className="mb-2">
								Der Artikelcode wird von "{oldCode}" zu "{newCode}" geändert.
								Dieser Artikel wird in folgenden Vorlagen verwendet:
							</p>
							<ul className="list-disc list-inside mb-2 max-h-40 overflow-y-auto">
								{templateNames.map((name, index) => (
									<li key={index} className="text-sm">
										{name}
									</li>
								))}
							</ul>
							<p className="text-sm text-muted-foreground">
								Möchten Sie den Artikel in den Vorlagen behalten oder entfernen?
							</p>
						</div>
					</DialogDescription>
				</DialogHeader>
				<DialogFooter className="flex-col sm:flex-row gap-2">
					<Button variant="outline" onClick={onCancel}>
						Abbrechen
					</Button>
					<Button variant="destructive" onClick={onRemoveFromTemplates}>
						Aus Vorlagen entfernen
					</Button>
					<Button variant="default" onClick={onKeepInTemplates}>
						In Vorlagen behalten
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};
